<pmt-top-navbar brandLogoSrc="assets/images/logos/asvz/logo-white-outlined.svg">
    <div class="d-flex gap-3" *ngIf="isLoggedIn">
        <div>
            <a class="btn nav-link-btn" [href]="staffToolUrl">
                <i class="fa-solid fa-arrow-right-from-bracket"></i>
                <span class="ms-1">{{'main.navbar.leave' | transloco}}</span>
            </a>
        </div>
        <div>
            <div class="dropdown cursor-pointer me-3" dropdown>
                <a class="btn nav-link-btn dropdown-toggle" dropdownToggle aria-controls="dropdown-animated">
                    <i class="fa-solid fa-user"></i>
                    <span class="ms-1" *ngIf="username">{{username}}</span>
                </a>

                <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                    <ng-container *ngIf="isAdmin">
                        <li>
                            <button class="dropdown-item cursor-pointer" (click)="directRedirectLoginToStaffTool()">
                                <i class="fa-solid fa-arrow-right-to-bracket"></i>
                                {{'main.navbar.leaveWithHandoff' | transloco}}
                            </button>
                        </li>
                        <div class="dropdown-divider"></div>
                    </ng-container>

                    <li>
                        <a class="dropdown-item cursor-pointer" (click)="logout()">
                            <i class="fa-solid fa-arrow-right-from-bracket"></i> {{'main.navbar.logout' | transloco}}
                        </a>
                    </li>
                    <!-- ToDo: Add Version Number -->
                    <!-- <li>
                        <div class="dropdown-divider"></div>
                        <span class="dropdown-item disabled">
                            <i class="fa fa-circle-info"></i> {{ 'main.navbar.versionPrefix' | transloco}}
                        </span>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</pmt-top-navbar>